export default {
    name: 'contentBannerCard',

    components: {},

    props: ['cBanner'],

    mixins: [],

    data(){
        return {

        }
    },

    methods: {}
};